import React, { useState, useEffect, useCallback, useRef } from "react";
import styles from "./SingleSelectWithInput.module.css";
import {
    FormControl,
    Select,
    MenuItem,
    OutlinedInput,
    ListItemText,
} from '@mui/material';


const SingleSelectWithInput = ({ width, placeholder, label, value, onChangeHandler, options = [], disabled = false, pageFrom='', backgroundColor }) => {
    const [searchText, setSearchText] = useState('');
    const [filteredOptions, setFilteredOptions] = useState(options);
    const compRef = useRef(null);


    const handleSearchChange = useCallback((event) => {
        const value = event.target.value;
        setSearchText(value);
    }, []);

    const handleFilterClick = useCallback((event) => {
        const value = event.target.value;
        onChangeHandler(label, value)
    }, [label, onChangeHandler]);


    useEffect(() => {
        if (options.length) {
            const lowerCaseSearch = searchText.toLowerCase();
            const visibleOptions = options.filter((opt) =>
                (typeof opt === 'string' && opt.toLowerCase().includes(lowerCaseSearch)) ||
                (typeof opt === 'number' && opt.toString().includes(searchText))
            );
            setFilteredOptions(visibleOptions);
        }
    }, [searchText, options]);

    // Handle outside clicks
    const handleClickOutside = (event) => {
        if (compRef.current && !compRef.current.contains(event.target)) {
            setSearchText('');
        }
    };

    // Add event listener on mount
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            // Cleanup on unmount
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);



    return (
        <div className={'Priortize matrix' === pageFrom ? styles.noclass : styles.labelFilterGroup} ref={compRef}>
            <FormControl
                sx={{
                    border: 'none',
                    borderRadius: 1,
                    '& .MuiOutlinedInput-root': {
                        border: 'none',
                        '& fieldset': {
                            borderColor: '#9F9F9F',
                        },
                        '&:hover fieldset': {
                            border: '1px solid #9F9F9F',
                        }
                    },
                }}
                ref={compRef}
            >
                <Select
                    displayEmpty
                    sx={{
                        height: '24px',
                        fontSize: '12px !important',
                        width: width || '150px',
                        backgroundColor: backgroundColor || '#FFFFFF',
                        padding: '0px'
                    }}
                    value={value}
                    renderValue={(selected) => selected || placeholder}
                    input={
                        <OutlinedInput />
                    }
                    disabled={disabled}
                    MenuProps={{
                        autoFocus: false,
                        PaperProps: { style: { maxHeight: '200px' } },
                    }}
                    onChange={handleFilterClick}
                >
                    {<MenuItem key="search" sx={{ padding: 0, borderBottom: '1px solid #ccc', '&.MuiMenuItem-root:hover': { backgroundColor: 'transparent' } }}>
                        <input
                            type="text" placeholder="Search..."
                            value={searchText}
                            onChange={handleSearchChange}
                            onClick={(e) => e.stopPropagation()}
                            onKeyDown={(e) => e.stopPropagation()}
                            style={{ border: 'none', height: '30px', width: '100%', paddingLeft: '5px' }}
                        />
                    </MenuItem>}
                    {filteredOptions.length > 0 && filteredOptions.map((opt, i) => (
                        <MenuItem
                            key={`option-${i}`}
                            value={opt}
                            sx={{
                                padding: '5px',
                                '& .MuiTypography-root': {
                                    fontSize: '12px',
                                },
                            }}
                        >
                            <ListItemText primary={opt} />
                        </MenuItem>
                    ))}

                </Select>
            </FormControl >
        </div>

    )
}

export default SingleSelectWithInput;